export default function useMethods(
    salon: Model.Response<Admin.Resources.Salon>
): Admin.Models.Salon.Methods {
    const type = {
        update: getUpdateTypeMethod(salon)
    }

    return { type }
}

function getUpdateTypeMethod(salon: Model.Response<Admin.Resources.Salon>) {
    return (type: Attributes.Salon.Type) => salon.setData(old => {
        if (!old) return old
        return { ...old, type }
    })
}